import React, { useState } from "react";
import { AlertCustomStyles } from "../layout/AlertCustomStyles";
import UserService from "../../services/user.service";
import { emailTypes } from "../../utils/constants";
const RegisterStepTwo = ({ onVerifyComplete, email, originalSentCode }) => {
  const [enteredCode, setEnteredCode] = useState("");
  const [sentCode, setSentCode] = useState(originalSentCode || "");
  const [error, setError] = useState("");
  const [alert, setAlert] = React.useState("");
  const handleVerify = () => {
    if (!!enteredCode && enteredCode.length) {
      if (sentCode == enteredCode) {
        onVerifyComplete();
      } else setAlert("fail");
    } else {
      setAlert("fail");
    }
  };
  const resend = () => {
    UserService.sendVerificationCode({
      email: email,
      emailType: emailTypes.VERIFY,
    })
      .then((res) => {
        //refresh modal
        setEnteredCode("");
        setAlert("success");
        setSentCode(res.code);
      })
      .catch((err) => {
        setAlert("Alert");
      });
  };
  return (
    <div className="mx-auto mt-2 w-full max-w-none">
      {alert && (
        <AlertCustomStyles
          status={alert}
          message={
            alert == "success"
              ? "New code sent. check your email"
              : "Invalid or incorrect Code, try again!"
          }
        />
      )}

      <div className="relative mx-auto w-full border-0 bg-transparent px-0 pb-4 pt-2 text-[#302521] shadow-none md:mb-2">
        <div className="mx-auto flex w-full flex-col gap-10">
          <div className="flex flex-col items-start justify-center space-y-2 text-left">
            <div className="text-2xl font-semibold">
              <p>Email Verification</p>
            </div>
            <div className="flex flex-row text-sm font-medium text-[#766b64]">
              <p>
                We have sent a code to your email{"   "}
                <b>
                  <span className="text-[#302521]">{email}</span>
                </b>
              </p>
            </div>
          </div>
          <div>
            <div class="flex flex-col space-y-16">
              <div className="mx-auto w-full max-w-xs">
                <div className="h-16 w-full">
                  <input
                    onChange={(e) => setEnteredCode(e.target.value)}
                    value={enteredCode}
                    className="flex h-full w-full flex-col items-center justify-center rounded-xl border border-[#d8cfc4] bg-[#fffdf9] px-5 text-center text-[40px] text-[#302521] outline-none focus:border-[#882699] focus:ring-1 focus:ring-[#882699]"
                    type="text"
                    name=""
                    maxLength={4}
                    onError={error}
                  />
                </div>
                {/* <div class="w-16 h-16 ">
                    <input
                      class="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-400 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                    />
                  </div>
                  <div class="w-16 h-16 ">
                    <input
                      class="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-400 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                    />
                  </div>
                  <div class="w-16 h-16 ">
                    <input
                      class="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-400 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                    />
                  </div> */}
              </div>

              <div class="flex flex-col space-y-5">
                <div>
                  <button
                    type="button"
                    onClick={handleVerify}
                    className="mt-6 block w-full select-none rounded-xl bg-[#882699] px-6 py-3.5 text-center text-sm font-semibold uppercase tracking-wide text-white shadow-[0_8px_24px_rgba(136,38,153,0.2)] transition hover:bg-[#9e32b4] focus:outline-none focus:ring-2 focus:ring-[#882699]/30 disabled:pointer-events-none disabled:opacity-50"
                  >
                    Verify Email
                  </button>
                </div>

                <div className="flex flex-row items-center justify-center space-x-1 text-center text-sm font-medium text-[#766b64]">
                  <p>Didn't receive code?</p>{" "}
                  <button
                    className="flex flex-row items-center text-[#882699] hover:text-[#6e1e7c]"
                    onClick={resend}
                  >
                    Resend
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RegisterStepTwo;
